/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
  } from "@vlinder-web/plugin-agent-service-react";
  import config from "../config/eventDetail.config.json";
  import {VApplication} from "../../../application";

  import { AppNavigatorService } from "../../appNavigatorService";

const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};
  
  export interface IButtonMethods extends IPluginMethodMap {
    getButtonProps(args: any): Promise<any>;
  }
  
  export class ButtonService implements IAgentPlugin {
    readonly methods: IButtonMethods;
  
    constructor() {
      this.methods = {
        getButtonProps: this.getProps.bind(this),
      };
    }
  
    async getProps(args: any) {
        console.log(`button args in service`, args);
      //Business Logic -> args has backend response + config has static content
      return this.getButtons(args);
    }

    private async getButtons(args:any) {
      let _buttons = [];
      _buttons.push(config?.timeLineButton);
      let whoami = await getWhoamiSrv()?.whoAmI();
      if (whoami?.whoami === "RISK_CAPITAL" && args?.status === "ACTIVE") {
        _buttons = [...config?.buttons, ..._buttons];
      }
      return _buttons;
    }
  }
  